import React from "react";
import { useTranslation } from "react-i18next";
import { ItemSchemaGroupList } from "../features/menu-editor/ItemSchemaGroupList";
import { withRestaurantId } from "../shared/components/layout";

const ItemSchemaGroupListWithId = withRestaurantId(ItemSchemaGroupList);

const EditorPage: React.FC = () => {
  const { t } = useTranslation();

  return <ItemSchemaGroupListWithId />;
};

export default EditorPage;
